module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAACE3AAAhNwEzWJ96AAABNUlEQVRoge3ZXQ3CMBSG4a8EAUhAAgJ2MwlIwMASHKChCpCAA24qYDhAAg5GluwQsrawnzJ6Ts57SUrCkzZjbaFpmqZpjDOpf3pTFTsAVwBHY93ZG7BQSWFvqE330d5Yd/EGLtDqh6gHgLs3cKGSzFgEVRrram8wF1iOKMyF5YrCHFjOKEyF5Y7CFBgHFMbCuKAwBsYJhaEwbigMgXFE4RuMKwqfYJxRiMG4oxCCSUChDwug2tr91M37ZkYZ605RWATFImOdt/KSbTRza/2aOuvqpirKwKxlvxRDeVMYWJL8Hx6UyMc9JfIPmhL5SkWJfAmmRG5bKJEbTUrk0QAl8jCHEnn8Rok8MKVEHnFTIi8lKJHXSFRuuGQbzQ5QdiB0wK03cKGS7qB7uMO/7p81TdM0jXUAnl4s1k+7+3QVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@3x/ic_btn_arrow_left@3x.png
// module id = 720
// module chunks = 0